import { render, staticRenderFns } from "./CustomerDetail-customerQuotations.vue?vue&type=template&id=780fe5b4&scoped=true"
import script from "./CustomerDetail-customerQuotations.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-customerQuotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780fe5b4",
  null
  
)

export default component.exports